/** Ajustes locales de la bandeja al archivar o deshacer, sin volver a pedir Gmail. */

export function esNoLeido(message) {
  if (!message) return false;
  if (message.unread) return true;
  return Array.isArray(message.labelIds) && message.labelIds.includes('UNREAD');
}

export function ajustarCountsAlQuitar(counts, message) {
  const next = { ...(counts || {}) };
  next.total = Math.max(0, Number(next.total || 0) - 1);
  if (esNoLeido(message)) next.unread = Math.max(0, Number(next.unread || 0) - 1);
  const accion = message?.clasificacion?.accion;
  if (accion && Object.prototype.hasOwnProperty.call(next, accion)) {
    next[accion] = Math.max(0, Number(next[accion] || 0) - 1);
  }
  if (message?.clasificacion?.auto) next.auto = Math.max(0, Number(next.auto || 0) - 1);
  return next;
}

export function ajustarCountsAlRestaurar(counts, message) {
  const next = { ...(counts || {}) };
  next.total = Number(next.total || 0) + 1;
  if (esNoLeido(message)) next.unread = Number(next.unread || 0) + 1;
  const accion = message?.clasificacion?.accion;
  if (accion && Object.prototype.hasOwnProperty.call(next, accion)) {
    next[accion] = Number(next[accion] || 0) + 1;
  }
  if (message?.clasificacion?.auto) next.auto = Number(next.auto || 0) + 1;
  return next;
}

export function siguienteVisible(lista, id) {
  const items = lista || [];
  const pos = items.findIndex((m) => m.id === id);
  if (pos < 0) return null;
  return items[pos + 1] || items[pos - 1] || null;
}

export function recontarMensajes(messages) {
  const counts = {
    total: 0,
    unread: 0,
    archivar: 0,
    responder: 0,
    seguir: 0,
    leer: 0,
    papelera: 0,
    tarea: 0,
    auto: 0,
  };
  for (const item of messages || []) {
    counts.total += 1;
    if (esNoLeido(item)) counts.unread += 1;
    const accion = item.clasificacion?.accion;
    if (accion && Object.prototype.hasOwnProperty.call(counts, accion)) {
      counts[accion] += 1;
    }
    if (item.clasificacion?.auto) counts.auto += 1;
  }
  return counts;
}

export function insertarEnIndice(lista, index, item) {
  const next = (lista || []).slice();
  const at = Math.max(0, Math.min(Number(index) || 0, next.length));
  next.splice(at, 0, item);
  return next;
}

const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const ANCHO_LISTA_DEFECTO = 420;
const ANCHO_LISTA_MIN = 280;
const ANCHO_LISTA_MAX = 900;

export function fechaMensajeMs(message) {
  if (!message) return NaN;
  if (message.internalDate != null && message.internalDate !== '') {
    const n = Number(message.internalDate);
    if (Number.isFinite(n)) return n;
  }
  const parsed = Date.parse(message.date || '');
  return Number.isFinite(parsed) ? parsed : NaN;
}

/** Fecha corta para la fila: hora si es hoy, «5 oct» este año, con año si es anterior. */
export function fechaListaCorta(message, now = new Date()) {
  const ms = fechaMensajeMs(message);
  if (!Number.isFinite(ms)) return '';
  const d = new Date(ms);
  const hoy = now instanceof Date ? now : new Date(now);
  if (Number.isNaN(hoy.getTime())) return '';
  const mismoDia = d.getFullYear() === hoy.getFullYear()
    && d.getMonth() === hoy.getMonth()
    && d.getDate() === hoy.getDate();
  if (mismoDia) {
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  }
  const corta = `${d.getDate()} ${MESES_CORTOS[d.getMonth()]}`;
  if (d.getFullYear() === hoy.getFullYear()) return corta;
  return `${corta} ${d.getFullYear()}`;
}

/** Ancho en px de la lista, acotado al panel y a un mínimo usable. */
export function anchoListaBandeja(px, { min = ANCHO_LISTA_MIN, max = ANCHO_LISTA_MAX, container = 0, reserva = 320 } = {}) {
  let upper = max;
  if (container > 0) upper = Math.min(max, Math.max(min, container - reserva));
  if (px == null || px === '') return Math.min(upper, ANCHO_LISTA_DEFECTO);
  const n = Number(px);
  if (!Number.isFinite(n)) return Math.min(upper, ANCHO_LISTA_DEFECTO);
  return Math.round(Math.min(upper, Math.max(min, n)));
}

const TZ_MADRID = 'Europe/Madrid';

function diaMadrid(date) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: TZ_MADRID }).format(date);
}

/** ms epoch de las 00:00 (hora de Madrid) de ayer; mismo criterio que el chip de correos de Mi día. */
export function inicioAyerMadrid(now = new Date()) {
  const [y, m, d] = diaMadrid(now).split('-').map(Number);
  const ayer = new Date(Date.UTC(y, m - 1, d - 1));
  const parte = new Intl.DateTimeFormat('en-US', { timeZone: TZ_MADRID, timeZoneName: 'longOffset' })
    .formatToParts(ayer).find((p) => p.type === 'timeZoneName').value;
  const mm = /GMT([+-])(\d{1,2})(?::?(\d{2}))?/.exec(parte);
  const minutos = mm ? (mm[1] === '-' ? -1 : 1) * (Number(mm[2]) * 60 + Number(mm[3] || 0)) : 0;
  return ayer.getTime() - minutos * 60000;
}

/** Sin leer recibidos ayer u hoy (los que cuenta Mi día). */
export function esNoLeidoReciente(message, now = new Date()) {
  if (!esNoLeido(message)) return false;
  const ms = message.internalDate ? Number(message.internalDate) : Date.parse(message.date || '');
  return Number.isFinite(ms) && ms >= inicioAyerMadrid(now);
}
